import { IProductGateway, ProductInput } from '@/core/interface';
import { ProductService } from '@/core/usecase';
import { Fragment, PresenterFunc, UpdaterFunc } from '@/core/interface/common';
import { Product } from '@/core/entity';

export class ProductController {
  private readonly service: ProductService;

  constructor(productGw: IProductGateway) {
    this.service = new ProductService(productGw);
  }

  public create(
    input: ProductInput,
    presenter: PresenterFunc<Product | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.createProduct(input, presenter, fragment, updater);
  }

  public update(
    id: string,
    input: ProductInput,
    presenter: PresenterFunc<Product | null>,
    fragment?: Fragment,
    updater?: UpdaterFunc,
  ) {
    this.service.updateProduct(id, input, presenter, fragment, updater);
  }
}
